document.addEventListener('DOMContentLoaded', () => {

/* ============================================
 *  PRIX DANS BOUTON ACHAT (AVEC VARIANT)
 * ============================================ */
/* ============================================
 *  SYNC PRIX → data-price-text du bouton (Dawn)
 *  - Priorité au prix promo
 *  - Optionnel : affiche l'ancien prix
 * ============================================ */
(function syncButtonPriceDataAttr(){
  const buttons = document.querySelectorAll('[id^="shopify-section-"] .product-form__submit[name="add"]');
  if (!buttons.length) return;

  buttons.forEach((btn) => {
    const section  = btn.closest('[id^="shopify-section-"]');
    if (!section) return;

    const priceBox = section.querySelector('[id^="price-"]') || section.querySelector('.price');
    if (!priceBox) return;

    const readCurrentPrice = () => {
  // Prix promo
  const saleEl = document.querySelector('.price__sale .price-item--sale.price-item--last');

  // Prix barré <s> dans price__sale
  const regularEl = document.querySelector('.price__sale s.price-item--regular');

  const saleTxt = saleEl ? saleEl.textContent.trim() : '';
  const regularTxt = regularEl ? regularEl.textContent.trim() : '';

  // Si promo : les deux existent et sont différents
  if (saleTxt && regularTxt) {
    return `${saleTxt} (au lieu de ${regularTxt})`;
  }

  return saleTxt || regularTxt || '';
};

    const sync = () => {
      const cur = readCurrentPrice();
      if (cur) btn.setAttribute('data-price-text', cur);
    };

    // init
    sync();

    // variante change → laisser Dawn maj, puis copier
    section.addEventListener('variant:change', () => {
      requestAnimationFrame(() => setTimeout(sync, 0));
    });
    document.addEventListener('variant:change', () => {
      requestAnimationFrame(() => setTimeout(sync, 0));
    });

    // observer les réécritures du prix
    if ('MutationObserver' in window){
      new MutationObserver(sync).observe(priceBox, { childList:true, subtree:true, characterData:true, attributes:true });
    }
  });
})();

  /* ================================
 * BOUTON D’ACHAT FLOTTANT (mobile)
 * ================================ */
(function initFloatingBuyBtn(){
  if (!window.matchMedia('(max-width: 990px)').matches) return;
  if (document.documentElement.dataset.floatingBtnInit === '1') return;
  document.documentElement.dataset.floatingBtnInit = '1';

  const submit =
    document.querySelector('#MainContent .product-form__submit[name="add"]') ||
    document.querySelector('.product-form__submit[name="add"]');

  if (!submit) return;

  // Crée la barre flottante
  const bar = document.createElement('div');
  bar.className = 'floating-buy-bar';
  bar.style.display = 'none'; // Cachée par défaut
  bar.innerHTML = `<button type="button" class="floating-buy-btn"></button>`;
  document.body.appendChild(bar);

  const btn = bar.querySelector('.floating-buy-btn');

  function currentLabel(){
    const label = (submit.querySelector('span')?.textContent || submit.textContent || '').trim();
    const price = submit.getAttribute('data-price-text');
    return price ? `${label} | ${price}` : label;
  }

  function sync(){
    btn.textContent = currentLabel();
    btn.disabled = (submit.hasAttribute('disabled') || submit.classList.contains('disabled'));
  }

  // Clic proxy
  btn.addEventListener('click', () => submit.click());

  // Gestion de l'affichage au scroll via IntersectionObserver
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Si le bouton d'origine n'est plus visible (on a scrollé plus bas)
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        bar.style.display = 'block';
      } else {
        bar.style.display = 'none';
      }
    });
  }, { threshold: 0 });

  observer.observe(submit);

  // Initialisation et suivi des changements (prix, variants)
  sync();
  if ('MutationObserver' in window){
    new MutationObserver(sync).observe(submit, { attributes:true, childList:true, subtree:true, characterData:true });
  }
  document.addEventListener('variant:change', () => { setTimeout(sync, 100); });
})();

  /* ===========================================
   *  CROP DESCRIPTION PRODUIT (mobile, N chars)
   * =========================================== */
  (function initTruncateDescription(){
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const desc = document.querySelector('#MainContent .product__description, #MainContent .product-description');
    if (!desc || desc.dataset.truncateInit === '1') return;
    desc.dataset.truncateInit = '1';

    const MAX_CHARS = 150; // ← ajuste ici

    const plainLen = (desc.textContent || '').trim().length;
    if (plainLen <= MAX_CHARS) return;

    const fullHTML = desc.innerHTML;

    function truncateHTMLByChars(html, limit){
      const src = document.createElement('div'); src.innerHTML = html;
      let count = 0; const out = document.createElement('div');

      function walk(node, parentOut){
        if (count >= limit) return;

        if (node.nodeType === Node.TEXT_NODE){
          const text = node.nodeValue || '';
          const remaining = limit - count;
          if (text.length <= remaining){
            parentOut.appendChild(document.createTextNode(text));
            count += text.length;
          } else {
            parentOut.appendChild(document.createTextNode(text.slice(0, remaining) + '…'));
            count = limit;
          }
          return;
        }

        if (node.nodeType === Node.ELEMENT_NODE){
          const clone = node.cloneNode(false);
          parentOut.appendChild(clone);
          for (const child of node.childNodes){
            if (count >= limit) break;
            walk(child, clone);
          }
        }
      }

      for (const child of src.childNodes){
        if (count >= limit) break;
        walk(child, out);
      }
      return out.innerHTML;
    }

    const shortHTML = truncateHTMLByChars(fullHTML, MAX_CHARS);

    // Structure + bouton centré
    desc.innerHTML = `
      <div class="desc-short">${shortHTML}</div>
      <div class="desc-full" hidden>${fullHTML}</div>
      <span class="read-more-btn" aria-expanded="false">Lire plus</span>
    `;

    const btn = desc.querySelector('.read-more-btn');
    const shortDiv = desc.querySelector('.desc-short');
    const fullDiv  = desc.querySelector('.desc-full');

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      if (expanded){
        fullDiv.hidden = true; shortDiv.hidden = false;
        btn.textContent = 'Lire plus'; btn.setAttribute('aria-expanded', 'false');
      } else {
        shortDiv.hidden = true; fullDiv.hidden = false;
        btn.textContent = 'Lire moins'; btn.setAttribute('aria-expanded', 'true');
      }
    });
  })();
});
